var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-toolbar-title',{attrs:{"id":"bar-text"}},[_c('router-link',{attrs:{"to":{ path: '/landing' }}},[_vm._v(" "+_vm._s(_vm.bartext)+" ")])],1),_c('v-spacer'),(
      _vm.settings.roles.includes('mp_alert_readonly') ||
      _vm.settings.roles.includes(
        'mp_selfservice_alert_readonly'
      ) ||
      _vm.settings.roles.includes('mp_alertmanager') ||
      _vm.settings.roles.includes('mp_admin')
    )?_c('v-chip',{staticClass:"white--text",attrs:{"color":"warning","to":"/table/alert_record"}},[_vm._v("Unread Alerts ("+_vm._s(_vm.alertCount)+")"),_c('v-icon',{staticClass:"ml-2",attrs:{"color":"white"}},[_vm._v(" mdi-bell-ring ")])],1):_vm._e(),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.toggleDarkMode}},[_c('v-icon',[_vm._v("mdi-theme-light-dark")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }